import React,{useState,useEffect} from 'react';
import "./MoreInfo.css";
import { Avatar } from '@material-ui/core';
import {useSelector,useDispatch} from 'react-redux';
import {useParams} from 'react-router-dom';
import { getMessages} from './Whatsappslice';
import {Link} from 'react-router-dom';
import { ArrowBack, ArrowBackIosOutlined } from '@material-ui/icons';
import { Icon, IconButton} from '@material-ui/core';
function MoreInfo() {
    const[seed,setseed]=useState("");
    var [time,settime]=useState();
    const {groupId} =useParams();
    const select=useSelector(getMessages);
    useEffect(()=>{setseed(Math.floor(Math.random()*1000));},[]);

    const groupdata=select.filter((elm)=>elm.id===groupId);
        

  return <div className="more">
<div className="more_container">
<Link to="/"><IconButton className='backIcon'><ArrowBack /></IconButton></Link>
<Avatar src={`https://avatars.dicebear.com/api/jdenticon/${seed}.svg `} style={{background:"white"}} />
<div className="more_text">
<h2>{groupdata[0].name}</h2>
    <h4>Created By <span style={{color:"Blue"}}>{groupdata[0].creater}</span></h4>
    <h4>Created at <span style={{color:"green"}}>
       {new Date(groupdata[0].timestamp.seconds*1000+((groupdata[0].timestamp.nanoseconds)/1000000)).toUTCString()}
        
        
        </span></h4>
</div>
<Link to={"/rooms/"+groupId}><button>Type a Message In This Group</button></Link>
</div>



  </div>;
}

export default MoreInfo;